import React from 'react'

import { JobNameAssignmentModal } from './../common/JobNameAssignmentModal/JobNameAssignmentModal'

import { useTemplateBasedJobPositionModal } from './hooks'

type TemplateBasedJobPositionModalProps = {
  template?: any
  onBack?: () => void
  onCancel: () => void
  onClose: () => void
  onConfirm: (data: any, callbacks: any) => unknown
  isOpen: boolean
}

export const TemplateBasedJobPositionModal = ({
  template,
  onBack,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}: TemplateBasedJobPositionModalProps) => {
  const { state, handlers } = useTemplateBasedJobPositionModal({
    onBack,
    onCancel,
    onClose,
    onConfirm,
  })

  const { nameAssignment, isConfirmationOpen } = state
  const {
    handleBack,
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
  } = handlers

  return (
    <JobNameAssignmentModal
      form={nameAssignment}
      onBack={handleBack}
      onCancel={handleCancel}
      onClose={handleClose}
      onConfirm={handleConfirm}
      onConfirmationCancel={handleConfirmationClose}
      onConfirmationClose={handleConfirmationClose}
      onConfirmationConfirm={handleConfirmationConfirm}
      {...{ template, isConfirmationOpen, isOpen }}
    />
  )
}
